import { gql } from '@apollo/client';
import _ from 'lodash';
import React from 'react';
import Badge from '../../components/Badge';
import { MenuItem } from '../../components/Menu';
import type { TopicGroupRow_GroupFragment } from '../../graphql/generated/graphqlTypes';
import GroupIcon from '../../groups/GroupIcon';
import TopicUserCollapsibleList from './TopicUserCollapsibleList';

const GROUP_FRAGMENT = gql`
  fragment TopicGroupRow_group on Group {
    id
    name
    allUsers {
      ...TopicUserCollapsibleList_members
    }
  }
  ${TopicUserCollapsibleList.fragments.members}
`;

interface TopicGroupRowProps {
  group: TopicGroupRow_GroupFragment;
  onRemove?: () => unknown;
  onToggleOwnership?: () => unknown;
  owner?: boolean;
}

const TopicGroupRow = ({
  group,
  onRemove,
  onToggleOwnership,
  owner = false,
}: TopicGroupRowProps) => {
  const menuItems = _.compact([
    onToggleOwnership && (
      <MenuItem key="owner" onClick={onToggleOwnership}>
        {owner ? 'Revoke ownership' : 'Make owner'}
      </MenuItem>
    ),
    onRemove && (
      <MenuItem key="remove" danger onClick={onRemove}>
        Remove from topic
      </MenuItem>
    ),
  ]);
  return (
    <TopicUserCollapsibleList
      icon={<GroupIcon />}
      name={group.name}
      badge={owner && <Badge inline={false}>Owner</Badge>}
      menu={menuItems.length > 0 ? menuItems : undefined}
      members={group.allUsers}
    />
  );
};

TopicGroupRow.fragments = {
  group: GROUP_FRAGMENT,
};

export default TopicGroupRow;
